jQuery(document).ready(function ($) {
  $(".banner-slide").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 600,

    accessibility: false,

    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,

    swipe: true,
    touchMove: true,
  });

  // setTimeout(function () {
  //     $(".related_product").slick({
  //       infinite: true,
  //       slidesToShow: 4,
  //       speed: 600,
  //       autoplay: false,
  //       draggable: true,
  //       focusOnSelect: true,
  //       dots:true,
  //       responsive: [
  //         {
  //           breakpoint: 1200,
  //           settings: {
  //             slidesToShow: 3,
  //           },
  //         },
  //         {
  //           breakpoint: 768,
  //           settings: {
  //             slidesToShow: 2,
  //           },
  //         },
  //         {
  //           breakpoint: 480,
  //           settings: {
  //             slidesToShow: 2,
  //           },
  //         },
  //       ],
  //     });
  //   }, 1000);

  $(".collection_product_slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  function initUpdateSlider() {
    var $slider = $(".update-slider");
    var totalSlides = $slider.children().length;
    var windowWidth = $(window).width();

    var slidesToShow = 4;

    if (windowWidth < 575) {
      slidesToShow = 1;
    } else if (windowWidth < 768) {
      slidesToShow = 2;
    } else if (windowWidth < 992) {
      slidesToShow = 3;
    } else {
      slidesToShow = 4;
    }

    // condition: slides > slidesToShow
    if (totalSlides > slidesToShow) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 4000,
          accessibility: false,
          appendArrows: $(".arrow_custom"),
          appendDots: $(".dots_custom"),
          responsive: [
            {
              breakpoint: 992,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 575,
              settings: { slidesToShow: 1 },
            },
          ],
        });
      }
    } else {
      // destroy if already initialized
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    }
  }

  // init
  initUpdateSlider();

  // resize pe recheck
  $(window).on("resize", function () {
    // initUpdateSlider();
  });

  function initUpdateSlider1() {
    var $slider = $(".update-slider1");
    var totalSlides = $slider.children().length;
    var windowWidth = $(window).width();

    var slidesToShow = 4;

    if (windowWidth < 575) {
      slidesToShow = 1;
    } else if (windowWidth < 768) {
      slidesToShow = 2;
    } else if (windowWidth < 992) {
      slidesToShow = 3;
    } else {
      slidesToShow = 4;
    }

    // condition: slides > slidesToShow
    if (totalSlides > slidesToShow) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 4000,
          accessibility: false,
          appendArrows: $(".arrow_custom1"),
          appendDots: $(".dots_custom1"),
          responsive: [
            {
              breakpoint: 992,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 575,
              settings: { slidesToShow: 1 },
            },
          ],
        });
      }
    } else {
      // destroy if already initialized
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    }
  }

  // init
  initUpdateSlider1();

  // resize pe recheck
  $(window).on("resize", function () {
    // initUpdateSlider1();
  });

  // why card content height js

  function equalHeight() {
    let max = 0;

    $(".why-card-content").css("height", "auto");

    $(".why-card-content").each(function () {
      max = Math.max(max, this.scrollHeight);
    });

    $(".why-card-content").height(max - "32");
  }

  $(window).on("load", function () {
    equalHeight();
    setTimeout(equalHeight, 300);
    setTimeout(equalHeight, 1000);
  });

  $(window).on("resize", equalHeight);

  //  $(function(){

  //   $(".explore-slider").slick({
  //     infinite:true,
  //     slidesToShow:2,
  //     slidesToScroll:1,
  //     speed:400,
  //     variableWidth:true,
  //     autoplay:false,
  //     draggable:true,
  //     focusOnSelect:true,
  //     adaptiveHeight:false,
  //     dots:true,
  //     arrows:true,
  //     responsive:[
  //       {
  //         breakpoint:767,
  //         settings:{
  //           slidesToShow:1,
  //           arrows:true,
  //           infinite:true,
  //           variableWidth:true,
  //           speed:300,
  //           centerMode:false,
  //           focusOnSelect:true
  //         }
  //       }
  //     ]
  //   });

  //   function setHeight(){
  //     let $n = $('.explore-slide.slick-current').next('.explore-slide');
  //     if(!$n.length) $n = $('.explore-slide').first();

  //     let h = $n.find('.explore-content').outerHeight();

  //     $('.slick-current .explore-content, .explore-slide.slick-current img.slide_img')
  //       .height(h);

  //     $('.explore-slider').slick('setPosition');
  //   }

  //   $('.explore-slider').on('init afterChange', setHeight);

  //   $(window).on('resize', setHeight);

  //   $('.explore-slider').on('mouseenter mouseleave','.explore-slide', () =>
  //     setTimeout(setHeight,400)
  //   );

  //   setTimeout(setHeight,300);

  // });

  $(function () {
    $(".explore-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 400,
      variableWidth: true,
      autoplay: false,
      draggable: true,
      focusOnSelect: true,
      adaptiveHeight: false,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: true,
            infinite: true,
            variableWidth: true,
            speed: 300,
            centerMode: false,
            focusOnSelect: true,
          },
        },
      ],
    });

    function equalHeight() {
      if ($(window).width() < 991) {
        $(".explore-content, .slide_img").css("height", "");
        return;
      }

      let maxHeight = 0;

      $(".explore-content").css("height", "auto");

      $(".explore-content").each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });

      $(".explore-content").height(maxHeight);
      $(".slide_img").height(maxHeight);

      $(".explore-slider").slick("setPosition");
    }

    $(".explore-slider").on("init", function () {
      setTimeout(equalHeight, 100);
    });

    $(".explore-slider").on("afterChange", function () {
      setTimeout(equalHeight, 100);
    });

    $(window).on("load resize", function () {
      setTimeout(equalHeight, 100);
    });

    setTimeout(equalHeight, 300);
  });

  $(".about_slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 2000,
  });

  var $nav = $(".application-nav");

  $(".application-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable:false,
    infinite: true,
    arrows: false,
    fade: true,
    dots: false,
    asNavFor: ".application-nav",
  });

  
  $nav.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    asNavFor: ".application-slider",
    focusOnSelect: true,
    swipeToSlide: true,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
         breakpoint: 768,
        settings: {
          vertical: true,
           verticalScrolling: true,
           infinite: false,
        },
        
      },
      {
        breakpoint: 575,
        settings: {
          
          arrows: false,
          dots: false,
          vertical: true,
          verticalScrolling: true,
          infinite:false,
          
        },
      },
    ],
  });

  $(".application-slider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      var currentTab = $(".application-slider .slide")
        .eq(currentSlide)
        .find(".label1")
        .text()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      $(".product-wrapper").removeClass("active");

      $('.product-wrapper[data-tab="' + currentTab + '"]').addClass("active");

      $(".swiper-wrapper").slick("destroy");
      setTimeout(function () {
        $(".swiper-wrapper").slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll:3,
          speed: 600,
          autoplay: false,
          draggable: true,
          focusOnSelect: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll:2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll:1,
              },
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1,
              },
            },
          ],
        });
      }, 300);
    },
  );
  // function updateSlideContentPosition() {
  //   $('.slide-content').each(function () {
  //       var imgHeight = $(this).siblings('.slide-img').outerHeight();
  //       $(this).css('top', (imgHeight + 30) + 'px');
  //   });
  // }

  // // Initial
  // updateSlideContentPosition();

  // // Resize
  // $(window).on('resize', function () {
  //     updateSlideContentPosition();
  // });

  if ($(window).width() <= 991) {
    $(".icon_list").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: false,

      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // faq start
  $(document).on("click", ".faq_item_ques", function () {
    $(this).toggleClass("on");
    $(this).next(".faq_item_ans").slideToggle();
    $(this)
      .parent(".faq_item")
      .siblings(".faq_item")
      .children(".faq_item_ans")
      .slideUp();
    $(this)
      .parent(".faq_item")
      .siblings(".faq_item")
      .children(".faq_item_ques")
      .removeClass("on");
  });

  // comman faq load more

  $(".faq_sec.if_faq.active:first-child .faq_item").hide();
  $(".faq_sec.if_faq.active:first-child .faq_item").slice(0, 7).show();

  if ($(".faq_sec.if_faq.active:first-child .faq_item").length > 7) {
    $(".load-more").css("visibility", "visible");
  } else {
    $(".load-more").css("visibility", "hidden");
  }

  jQuery("body").on("click touchstart", ".load-more", function (e) {
    e.preventDefault();
    jQuery(".faq_sec.if_faq.active:first-child .faq_item:hidden")
      .slice(0, 7)
      .slideDown();
    if ($(".faq_sec.if_faq.active:first-child .faq_item:hidden").length == 0) {
      $(".load-more").css("visibility", "hidden");
    }
  });

  // product descption readmore - less start
  $(".show_more_desc").addClass("hide_more_desc");
  $(".desc_showmore_btn").on("click", function () {
    //var txt = $(".show_more_desc").is(":visible") ? "Show More" : "Show Less";
    if ($(this).text() == "Show More") {
      $(this).text("Show Less");
    } else {
      $(this).text("Show More");
    }

    // $(this).text(txt);
    $(this)
      .parents(".desc_show_more")
      .prev(".show_more_desc")
      .toggleClass("hide_more_desc");
  });
});

$(document).ready(function () {
  $(".count span").each(function () {
    let $this = $(this);
    let target = parseInt($this.text());
    let count = 0;
    let speed = target / 200;

    $this.text(0);

    let counter = setInterval(function () {
      count += speed;

      if (count >= target) {
        $this.text(target);
        clearInterval(counter);
      } else {
        $this.text(Math.floor(count));
      }
    }, 10);
  });
});

$(document).ready(function () {
  const $box = $("#compare_img");
  const $after = $box.find(".after_img");
  const $divider = $box.find(".divider_img");
  const $handle = $box.find(".handle_img");

  function moveSlider(clientX) {
    let rect = $box[0].getBoundingClientRect();
    let x = clientX - rect.left;

    if (x < 0) x = 0;
    if (x > rect.width) x = rect.width;

    let percent = (x / rect.width) * 100;

    $after.css("clip-path", `inset(0 ${100 - percent}% 0 0)`);
    $divider.css("left", percent + "%");
    $handle.css("left", percent + "%");
  }

  // Desktop drag
  $box.on("mousemove", function (e) {
    if (e.buttons === 1) {
      moveSlider(e.clientX);
    }
  });

  // Mobile drag
  $box.on("touchmove", function (e) {
    e.preventDefault(); // prevent browser swipe gesture

    moveSlider(e.originalEvent.touches[0].clientX);
  });
});

$(document).ready(function () {
  const $slider = $("#brochure_slider");
  const $dotsContainer = $("#brochure_dots");

  let data = $slider
    .children()
    .map(function () {
      return $(this).html();
    })
    .get();

  let index = 0;
  let isInitialized = false;
  let isActive = false;

  /* ========= RESPONSIVE COUNT ========= */
  function getSlidesToShow() {
    if (window.innerWidth < 576) return 2;
    if (window.innerWidth < 992) return 3;
    return 4;
  }

  /* ========= RENDER ========= */
  function render() {
    let count = getSlidesToShow();
    let html = "";

    for (let i = 0; i < count; i++) {
      let realIndex = (index + i) % data.length;
      let cls = "l" + i;

      html += `
        <div class="brochure-slide ${cls}" data-index="${realIndex}">
          ${data[realIndex]}
        </div>
      `;
    }

    $slider.html(html);
    updateDots();
  }

  /* ========= DOTS ========= */
  function createDots() {
    let html = "";
    data.forEach((_, i) => {
      html += `<span class="dot" data-index="${i}"></span>`;
    });
    $dotsContainer.html(html);
  }

  function updateDots() {
    $(".dot").removeClass("active").eq(index).addClass("active");
  }

  /* ========= INIT ========= */
  function initSlider() {
    if (isInitialized) return;

    createDots();
    render();

    isInitialized = true;
  }

  /* ========= EVENTS ========= */

  // Slide click
  $slider.on("click", ".brochure-slide", function () {
    if (!isInitialized || !isActive) return;

    index = $(this).data("index");
    render();
  });

  // Dots click
  $dotsContainer.on("click", ".dot", function () {
    if (!isActive) return;

    index = $(this).data("index");
    render();
  });

  function next() {
    if (!isActive) return;

    index = (index + 1) % data.length;
    render();
  }

  function prev() {
    if (!isActive) return;

    index = (index - 1 + data.length) % data.length;
    render();
  }

  $("#brochure_next").on("click", function (e) {
    e.stopPropagation();
    next();
  });

  $("#brochure_prev").on("click", function (e) {
    e.stopPropagation();
    prev();
  });

  /* ========= DRAG ========= */
  let startX = 0;
  let isDown = false;

  $slider.on("mousedown touchstart", function (e) {
    if (!isInitialized || !isActive) return;

    isDown = true;
    startX =
      e.type === "touchstart" ? e.originalEvent.touches[0].clientX : e.clientX;
  });

  $slider.on("mouseup touchend", function (e) {
    if (!isInitialized || !isActive || !isDown) return;

    let endX =
      e.type === "touchend"
        ? e.originalEvent.changedTouches[0].clientX
        : e.clientX;

    let diff = endX - startX;

    if (diff < -50) next();
    if (diff > 50) prev();

    isDown = false;
  });

  /* ========= RESPONSIVE CHECK ========= */
  function checkSlider() {
    if ($(window).width() > 767) {
      if (!isInitialized) {
        initSlider();
      }
      isActive = true; // ENABLE
    } else {
      isActive = false; // DISABLE (no destroy)
    }
  }

  /* ========= RESIZE ========= */
  let t;
  $(window).on("resize", function () {
    clearTimeout(t);
    t = setTimeout(function () {
      checkSlider();

      // resize pe render bhi update ho
      if (isInitialized && isActive) {
        render();
      }
    }, 200);
  });

  /* ========= INIT ========= */
  checkSlider();
});

$(document).ready(function () {
  if ($(window).width() <= 767) {
    let $slider = $("#brochure_slider");

    // ORIGINAL slides ka data store karlo (IMPORTANT)
    let slidesData = [];

    $slider.find(".brochure-slide").each(function () {
      slidesData.push($(this).html());
    });

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      appendDots: $("#brochure_dots"),
    });

    // INIT
    setActiveSlide(0);
    $slider.on("click", ".slick-slide", function () {
      let index = $(this).attr("data-slick-index"); // 🔥 important
      index = parseInt(index);
      // negative index handle (slick clones)
      if (index < 0) {
        index = $slider.slick("getSlick").slideCount + index;
      }
      setActiveSlide(index);
      $slider.slick("slickGoTo", index);
    });
    // SWIPE / AUTO CHANGE
    $slider.on("afterChange", function (event, slick, currentSlide) {
      setActiveSlide(currentSlide);
    });
    function setActiveSlide(index) {
      $("#brochure_active").html(slidesData[index]);
    }
  }
});

$(document).ready(function () {
  if ($(".container-brochure-m").length > 0) {
    function setLayout() {
      let $container = $(".container").first();
      let $inner = $(".container-brochure-m .brochure-inner");
      if ($(window).width() <= 767) {
        let windowWidth = $(window).width();
        let containerOffset = $container.offset().left;
        // 🔥 px → vw conversion
        let offsetVW = (containerOffset / windowWidth) * 100;
        let finalVW = 100 - offsetVW;
        $inner.css({
          width: finalVW + "vw",
        });
      } else {
        $inner.css({
          width: "",
        });
      }
    }
    setLayout();
    $(window).on("resize", setLayout);
  }
});
$(document).ready(function () {
  $(".swiper-wrapper").each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 3,
      speed: 600,
      autoplay: false,
      draggable: true,
      focusOnSelect: true,
      variableWidth: false,
      centerMode: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  /*--SCROLL ANIMATION--*/
  new WOW().init();

  // custom select
  // $(document).ready(function () {
  //   // Initialize default value (first option) for each custom select
  //   $(".custom-select").each(function() {
  //       let $firstOption = $(this).find(".custom-option").first();
  //       if ($firstOption.length) {
  //           let initValue = $firstOption.data("value");
  //           let initText = $firstOption.text();

  //           $(this).find(".custom-select__trigger span").text(initText);
  //           $(this).find("input").val(initValue);
  //           $firstOption.addClass("selected");
  //       }
  //   });

  //   // toggle dropdown
  //   $(".custom-select__trigger").on("click", function () {
  //       $(this).parent().toggleClass("open");
  //   });

  //   // select option
  //   $(".custom-option").on("click", function () {
  //       let value = $(this).data("value");
  //       let text = $(this).text();

  //       let parent = $(this).closest(".custom-select");

  //       // Highlight selected option
  //       $(this).siblings().removeClass("selected");
  //       $(this).addClass("selected");

  //       parent.find(".custom-select__trigger span").text(text);
  //       parent.find("input").val(value);

  //       parent.removeClass("open");
  //   });

  //   // close when clicking outside
  //   $(document).on("click", function (e) {
  //       if (!$(e.target).closest(".custom-select").length) {
  //           $(".custom-select").removeClass("open");
  //       }
  //   });

  // });

  // select2 js

  // $(function(){
  //   $('.form-select').select2({
  //     placeholder: "Select Your Requirement*",
  //     minimumResultsForSearch: Infinity // 🔥 remove search box
  //   });
  // });

  $(".form_validate .form-select").each(function () {
    let placeholder = $('label[for="' + this.id + '"]')
      .text()
      .trim();

    $(this).select2({
      placeholder: placeholder,
      minimumResultsForSearch: Infinity,
    });
  });

  $(document).on("click", ".teams_items a", function (e) {
    e.preventDefault();

    var target = $(this).data("bs-target");

    const modalElement = document.querySelector(target);

    if (modalElement) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
      modal.show();
    }
  });

  function initRelatedSlider() {
    const $slider = $(".related_product");

    if (
      $slider.length &&
      !$slider.hasClass("slick-initialized") &&
      $slider.find("li").length > 0
    ) {
      $slider.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        speed: 600,
        autoplay: false,
        draggable: true,
        focusOnSelect: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }

  // check every 500ms until products are loaded
  const sliderInterval = setInterval(function () {
    if ($(".related_product li").length) {
      initRelatedSlider();
      clearInterval(sliderInterval);
    }
  }, 500);

  (function ($) {
    function initMobileSlider() {
      $(".hex-grid").each(function () {
        const $slider = $(this);

        if (window.matchMedia("(max-width: 991px)").matches) {
          if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
              infinite: false,
            });
          }
        } else {
          if ($slider.hasClass("slick-initialized")) {
            $slider.slick("unslick");
          }
        }
      });
    }

    $(window).on("load", initMobileSlider);

    $(window).on("resize.hexGridSlider", function () {
      clearTimeout(window.hexGridSliderResize);

      window.hexGridSliderResize = setTimeout(function () {
        initMobileSlider();
      }, 200);
    });
  })(jQuery);

// home collection tab product swiper-wraper slider

});

if ($(window).width() <= 767) {
    $(".innovation-compabilities .row").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: false,

      responsive: [
        {
          breakpoint: 575,
          settings: {
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  }



  function stepToggle() {
  if ($(window).width() <= 991) {
    $('.step-content').hide();
    $('.step-card').off('click').on('click', function () {
      $(this).toggleClass('active')
        .find('.step-content').stop().slideToggle(300);
      $(this).siblings().removeClass('active')
        .find('.step-content').stop().slideUp(300);
    });
  } else {
    $('.step-card').off('click');
    $('.step-content').show();
  }
}

stepToggle();
$(window).on('resize', stepToggle);

if ($(window).width() <= 767) {
    $(".scene-cards .row").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: false,

      responsive: [
        {
          breakpoint: 575,
          settings: {
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });

    $(".tech-wrap").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      draggable: true,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: false,

      responsive: [
        {
          breakpoint: 575,
          settings: {
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  }

if ($(window).width() <= 767) {
  $(function () {
    $('#purpose .fu p').each(function () {
      let t = $(this).text().trim(),
          l = 122;

      if (t.length > l) {
        $(this).html(`
          <span class="short">${t.slice(0,l)}... <a href="#" class="toggle">Read More</a></span>
          <span class="full" style="display:none;">${t} <a href="#" class="toggle">Read Less</a></span>
        `);
      }
    });

    $(document).on('click', '.toggle', function (e) {
      e.preventDefault();
      $(this).closest('span').hide().siblings().show();
    });
  });
};

$(function () {

    function initSlider() {
        if ($(window).width() < 992) {

            if (!$('.leader-slider').hasClass('slick-initialized')) {
                $('.leader-slider').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:false,
                    dots:false,
                    responsive: [
                        {
                            breakpoint: 768, 
                            settings: {
                                slidesToShow: 1
                            }
                        },
                    ]
                });
            }

        } else {

            if ($('.leader-slider').hasClass('slick-initialized')) {
                $('.leader-slider').slick('unslick');
            }

        }
    }

    initSlider();
    $(window).on('resize', initSlider);

});

$(function () {
    function initSlider() {
        if ($(window).width() < 992) {
            if (!$('.js-sr-process').hasClass('slick-initialized')) {
                $('.js-sr-process').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                    dots:false,
                    responsive: [
                        {
                            breakpoint: 768, 
                            settings: {
                                slidesToShow: 1
                            }
                        },
                    ]
                });
            }

        } else {

            if ($('.js-sr-process').hasClass('slick-initialized')) {
                $('.js-sr-process').slick('unslick');
            }

        }
    }

    initSlider();
    $(window).on('resize', initSlider);

});
$(function () {
    function initSlider() {
        if ($(window).width() < 992) {
            if (!$('.js-sr-insights').hasClass('slick-initialized')) {
                $('.js-sr-insights').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                    dots:false,
                    responsive: [
                        {
                            breakpoint: 768, 
                            settings: {
                                slidesToShow: 1
                            }
                        },
                    ]
                });
            }

        } else {

            if ($('.js-sr-insights').hasClass('slick-initialized')) {
                $('.js-sr-insights').slick('unslick');
            }

        }
    }

    initSlider();
    $(window).on('resize', initSlider);

});

if ($(window).width() < 992) {
  $('.sr-app__feature').on('click', function () {
      if ($(this).hasClass('active')) {
          $(this).removeClass('active')
                .find('p').stop().slideUp(300);
      } else {
          $('.sr-app__feature.active')
              .removeClass('active')
              .find('p').stop().slideUp(300);

          $(this).addClass('active')
                .find('p').stop().slideDown(300);
      }
  });
}

if($(window).width() <= 767){
  $('.sr-bms__badges').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots:true,
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    });

    $('.sr-onprem__grid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 2,
      infinite: true,
      arrows: false,
      dots: false,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rows: 2
              }
          }
      ]
  });
  $('.product-feature-icon .icon-title').on('click', function () {
    let $box = $(this).parent();

    if ($box.hasClass('active')) {
        $box.removeClass('active').find('.icon-desc').stop().slideUp(300);
    } else {
        $('.product-feature-icon .icon-box.active')
            .removeClass('active')
            .find('.icon-desc')
            .stop()
            .slideUp(300);

        $box.addClass('active').find('.icon-desc').stop().slideDown(300);
    }
});
}

$(".mbHead .modal__toggle").click(function () {
  setTimeout(function () {
    $("summary.header__icon.header__icon--search").trigger("click");
  }, 200);
});